<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{title}}</title>
    <g :fill="fill">
      <rect x="10" y="32" width="8" height="8" rx="1"></rect>
      <rect x="10" y="22" width="8" height="8" rx="1"></rect>
      <rect x="20" y="32" width="8" height="8" rx="1"></rect>
      <rect x="20" y="22" width="8" height="8" rx="1"></rect>
      <rect x="30" y="22" width="8" height="8" rx="1"></rect>
      <path d="M12,11a1,1,0,0,1-1-1V2a1,1,0,0,1,2,0v8A1,1,0,0,1,12,11Z"></path>
      <path d="M44,5H39v5a3,3,0,0,1-6,0V5H15v5a3,3,0,0,1-6,0V5H4A3,3,0,0,0,1,8V43a3,3,0,0,0,3,3H44a3,3,0,0,0,3-3V8A3,3,0,0,0,44,5Zm1,38a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V18H45Z"></path>
      <path d="M36,11a1,1,0,0,0,1-1V2a1,1,0,0,0-2,0v8A1,1,0,0,0,36,11Z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Calendar",
  props: {
    title: {
      default: 'Calendrier',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
}
</script>
